
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Footer from './footer.vue'
import { enterFullScreen } from '@xt/client/helpers/system'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: { Footer }
})
export default class LivePageView extends Vue {
  @Prop({ default: false }) toggle: boolean
  @Prop({ default: false }) fullscreen: boolean

  controlVisible = true
  controlDuration = 4000
  controlTimer: ReturnType<typeof setInterval> | null = null

  get PageStore() {
    return this.$store.$genseeLive
  }

  @Ref('doc-widget-box')
  docWidgetBox: HTMLDivElement

  @Debounce(600, { leading: true, trailing: false })
  @Bind()
  handleDocDblClick() {
    this.$emit('toggle-fullscreen', 'doc')
  }

  docBoxMoveHandler() {
    if (!this.PageStore.isFullScreen) return
    this.recoverControlTimer()
  }

  resetControlTimer() {
    this.controlVisible = false
    if (this.controlTimer) {
      clearTimeout(this.controlTimer)
      this.controlTimer = null
    }
  }

  recoverControlTimer() {
    this.controlVisible = true
    if (this.controlTimer) {
      clearTimeout(this.controlTimer)
      this.controlTimer = null
    }
    this.controlTimer = setTimeout(this.resetControlTimer, this.controlDuration)
  }

  fullscreenHandler() {
    const targetNode = document.querySelector('#doc-live-widget-box') as HTMLDivElement
    enterFullScreen(targetNode)
    this.PageStore.setCurrentFullScreenNode('doc')
  }

  @Watch('fullscreen')
  changeFullscreen(value: boolean) {
    if (value) {
      this.recoverControlTimer()
    }
  }

  created() {}
  mounted() {}
  destroyed() {}
}
